import React from 'react';
import { useRecoilState } from 'recoil';
import { toggleModal, costEstimateState } from 'pages/reference-implementation/provisioning/RI001/store';
import CostDetails from 'pages/reference-implementation/components/cost-details';

export const ShowCostDetails = () => {
    const [costEstimate] = useRecoilState(costEstimateState);
    const [modal, setModal] = useRecoilState(toggleModal);
    return (
        <CostDetails
            type={modal?.isCost?.costType}
            isCostOpen={modal?.isCost?.isCostOpen}
            costEstimate={costEstimate}
            handleCloseModal={() => setModal({ ...modal, isCost: { costType: '', isCostOpen: false } })}
        />
    );
};

ShowCostDetails.propTypes = {};

ShowCostDetails.defaultProps = {};

export default ShowCostDetails;
